var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clock_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Clock_svg__st1{fill:#262a30}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clock_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -17)",
    id: "Clock_svg__SYMBOLS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clock_svg__noun_clock_396274",
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clock_svg__Shape",
    className: "Clock_svg__st1",
    d: "M32 17.3c-8.1 0-14.7 6.6-14.7 14.7S23.9 46.7 32 46.7 46.7 40.1 46.7 32 40.1 17.3 32 17.3zM32 44c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clock_svg__Path",
    className: "Clock_svg__st1",
    d: "M33.3 22.7h-2.6v10.1l6.4 3.7 1.4-2.3-5.2-3z"
  })))));
};
export default SvgClock;